import React, { useState, useEffect } from 'react';
import Loader from '../Common/Loader';
import axios from 'axios';
import constants from '../../constants';
import { cookieStorageUtility } from '../../utils/utilityFunctions';
import { checkRole } from '../Common/CheckRole';
import { useNavigate, useParams } from 'react-router-dom';
import ReactPaginate from 'react-paginate';

const { serverUrl, ENCRYPTOR_KEY } = constants;
const authUserId = cookieStorageUtility.fetch('auth_user_id');
const encryptedToken = cookieStorageUtility.fetch('encrypted_' + ENCRYPTOR_KEY + '_token');

const UserWrapper = () => {
  const  navigate = useNavigate();
  const { id } = useParams();
  const [list, setList] = useState([]); 
  const [flag, setFlag] = useState(false);
  const [type, setType] = useState('error');
  const [message, setMessage] = useState('');
  const [showUILoader, setShowUILoader] = useState(false);
  const [show, setShow] = useState([]);
  const [limit] = useState(20);
  const [pageNumber, setPageNumber] = useState(1);
  const [total, setTotal] = useState(0);
  const [pageRangeDisplayed] = useState(5);
  const [counter, setCounter] = useState(0);
  const types = {
    all: 'All',
    city: 'City',
    country: 'Country',
    hotel: 'Hotel'
  };

  useEffect(() => {
    getUserList();
    // eslint-disable-next-line
  }, [pageNumber]);

   // Handle page change
  const handlePageChange = (selectedPage) => {
    const newPageNumber = selectedPage.selected + 1; // ReactPaginate uses 0-based indexing
    const newCounter = newPageNumber <= 1 ? 0 : (newPageNumber - 1) * limit;
    
    setPageNumber(newPageNumber);
    setCounter(newCounter);
    
    // Call getActivityLogs after state is updated
    setTimeout(() => {
      getUserList();
    }, 0);
  };

  const showMessage = (type, msg) => {
    setFlag(true);
    setType(type);
    setMessage(msg);
    setTimeout(() => setFlag(false), 5000);
  };

  const getUserList = (userName = '') => {
    setShowUILoader(true);
    axios(serverUrl + 'users/userlist', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        token: btoa(authUserId + '|' + encryptedToken)
      },
      data: { user_name: userName, page: pageNumber, limit: limit }
    })
      .then(response => {
        if (response.data.status === 'success') {
          setList(response.data.data);
          setTotal(response.data.count);
        } else {
          showMessage('error', response.data.message);
        }
        setShowUILoader(false);
      })
      .catch(error => {
        console.log(error);
        setShowUILoader(false);
      });
  };

  const editUser = (id) => {
    navigate(`/user/edit/${id}`);
  };

  const showDetailToggel = (id) => {
    if (show.indexOf(id) > -1) {
      const currentUser = [...show];
      let value = parseInt(id);
      currentUser.splice(currentUser.indexOf(value), 1);
      setShow(currentUser);
    } else {
      let currentUser = [...show];
      let value = parseInt(id);
      currentUser = [];
      currentUser.push(value);
      setShow(currentUser);
    }
  };

  const renderList = () => {
    return list.map((val, id) => {
      return (
        <div className="wrapper" key={id}>
          <div className="accordion_col ovr">
            <div className="table_col table_fixed border_t_1 border_color_1">
              <div className="tabcel align_top pad10 wdhpx250" >
                {val.name}
              </div>
              <div className="tabcel align_top pad10 wdhpx150" >
                {val.email}
              </div>
              <div className="tabcel align_top pad10 wdhpx150" >
                {val.mobile}
              </div>
              <div className="tabcel align_top pad10 wdhpx150" >
                {(val.roles.length > 0) ? val.roles.join(' | ') : ''}
              </div>
              <div className="tabcel align_top pad10 wdhpx50">
                <div className="row">
                  <div className="col-xs tc">
                    <i
                      className="fa fa-pencil fnt15 color7 cursor_p"
                      title="Edit"
                      onClick={() => editUser(val.userId)}
                    ></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    });
  };

  return (
    <React.Fragment>
      {showUILoader ? <Loader /> : ''}
      <div className="container_fluid topheading pad_lft_rht25 pad_top_bot15 text-start">
        <div className="row">
          <div className="col-xs">
            <div className="d-full-height justify-content-center fnt18 tu">User List</div>
          </div>
        </div>
      </div>
      {flag ? (
        <div
          className={`alert_col posfixed pad10 tc fnt16 bld ${type === 'error' ? 'danger' : 'success'}`}
        >
          {message}
        </div>
      ) : ''}
      <div className="container_fluid pad_lft_rht25 padtop10 bg2_12 boder_b_1 border_color_1 text-start">
        <div className="row gutters-5">
          <div className="col-xs-12 col-md-6 marg_bottom10">
            <div className="frm border_all_1 border_color_1">
              <input type="text" placeholder="Enter user name or email id" className="input pad_lft_rht5" onChange={(e) => getUserList(e.target.value)} />
            </div>
          </div>
        </div>
      </div>
      <div className="container_fluid pad_lft_rht20 padtop25 text-start">
        <div className="cover border_all_1 border_color_1">
          <div className="scroll_485">
            <div className="scroll_inner_485">
              <div className="wrapper">
                <div className="table_col table_fixed bg2_8">
                  <div className="tabcel align_middle pad10 bld wdhpx250">NAME</div>
                  <div className="tabcel align_middle pad10 bld wdhpx150">EMAIL</div>
                  <div className="tabcel align_middle pad10 bld wdhpx150">MOBILE</div>
                  <div className="tabcel align_middle pad10 bld wdhpx150">ROLE</div>
                  <div className="tabcel align_middle pad10 tc bld wdhpx50">ACTION</div>
                </div>
              </div>
              {renderList()}
            </div>
            {total === 0 && !showUILoader ? (
              <div className="cover pad30 border_t_1 border_color_1">
                <div className="ovr tc marg_bottom10">
                  <div className="inline">
                    <img src="/images/no_result.png" alt="No Booking Found" />
                  </div>
                </div>
                <div className="ovr tc fnt16 bld">No User Found</div>
              </div>
            ) : ''}
          </div>
        </div>
        {total > limit ? (
          <div className="cover tc margtop15">
           <ReactPaginate
              breakLabel="..."
              nextLabel="Next >"
              onPageChange={handlePageChange}
              pageRangeDisplayed={2}
              pageCount={Math.ceil(total / limit)}
              previousLabel="< Prev"
              forcePage={pageNumber - 1}
              containerClassName="pagination"
              activeClassName="active"
              marginPagesDisplayed={0}
            />
          </div>
        ) : ''}
      </div>
    </React.Fragment>
  );
};

export default UserWrapper;
